import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-exception',
  templateUrl: './exception.component.html',
  styleUrls: ['./exception.component.scss']
})
export class ExceptionComponent implements OnInit {
  public id: string;
  numberLeft: string;
  numberRight: string;
  description: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id === '404'){
      this.numberLeft = '4';
      this.numberRight = '4';
      this.description = 'Vui lòng đăng nhập lại để cập nhật phiên bản mới hơn!';
    }else if (this.id === '401'){
      this.numberLeft = '4';
      this.numberRight = '1';
      this.description = 'Tài khoản không được ủy quyền vui lòng đăng nhập lại!';
    }else if (this.id === 'timeout'){
      this.numberLeft = 'ERR';
      this.numberRight = 'R';
      this.description = 'Hết phiên đăng nhập vui lòng đăng nhập lại!';
    }
  }
  routertoLogin(){
    this.router.navigate(['/project']);
  }
}
